// The Next Action of a customer = the open task with the earliest EFFECTIVE due time (the server annotates each task with `effective_due_at`: the
// explicit due date, else created + 7 days), ties broken by task id - the same rule the Customers grid and the Calls queue use. It must not depend on
// the order the list happens to arrive in (Customer 360 lists tasks newest-created first).
export function pickNextTask(tasks, opp) {
  const eligible = (tasks || []).filter(
    (t) => t.status === "open" && !t.cross_product && !t.journey_stale && (!opp || t.opportunity_id === opp.opportunity_id),
  );
  if (!eligible.length) return undefined;
  const key = (t) => {
    const ms = Date.parse(t.effective_due_at || "");
    return Number.isNaN(ms) ? Infinity : ms;
  };
  return eligible.reduce((best, t) => {
    const a = key(t);
    const b = key(best);
    if (a < b) return t;
    if (a > b) return best;
    return String(t.task_id || "") < String(best.task_id || "") ? t : best;
  });
}
